module.exports = __webpack_public_path__ + "media/img/pages/companies/unilever-e0b04c444071ac987678256a759dcd3d.jpg";